<div id="sliderImagesCarouselControls" class="carousel slide">
  <div class="carousel-inner">
    <div class="carousel-item" [ngClass]="pgind == 0?'active':''" *ngFor="let page of Pages,let pgind = index">
       <div class="images" *ngFor="let img of page,let imind = index">
            <img loading="lazy" (click)="imgselect(imind+(pgind*5))" src="{{img}}" alt="Vehicle details image {{imind+(pgind*5)+1}}" data-bs-target="#sliderCarouselControls" [attr.data-bs-slide-to]="imind+(pgind*5)">
       </div>
    </div>
    <a *ngIf="Pages.length>1" class="carousel-control-prev" href="#sliderImagesCarouselControls" type="button" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      </a>
      <a *ngIf="Pages.length>1" class="carousel-control-next" href="#sliderImagesCarouselControls" type="button" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
      </a>
</div>
</div>
